export default __webpack_public_path__ + "images/80c6ff162148ac1a20415a4efbdcbfd1-product-details.svg";